export default __webpack_public_path__ + "fonts/merriweather.woff2";